import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../Configurations/AuthContext";
import { showMenu } from "./CompanyMenu";
import { isPlanExpired } from "./dateUtils";
import DefaultData from "../../CompanyData/DefaultData";

const ComingSoonItem = ({ icon, label }) => {
  const disabledLinkStyle = {
    display: "flex",
    alignItems: "center",
    padding: "0.6rem 1.1rem",
    borderRadius: "0.5rem",
    textDecoration: "none",
    color: DefaultData.THEMECOLOR3,
    fontWeight: "500",
    cursor: "not-allowed",
    position: "relative",
  };

  const badgeStyle = {
    position: "absolute",
    top: "-5px",
    right: "-5px",
    fontSize: "0.6rem",
    fontWeight: "bold",
    padding: "0.1rem 0.4rem",
    borderRadius: "1rem",
    backgroundColor: DefaultData.THEMECOLOR2,
    color: DefaultData.THEMECOLOR3,
  };

  return (
    <div style={disabledLinkStyle}>
      <i className={`${icon} me-2`}></i>
      <span>{label}</span>
      <span style={badgeStyle}>SOON</span>
    </div>
  );
};

// Dropdown component for Bookings
const BookingsDropdown = ({ activeSection, getStyle }) => {
  const [isOpen, setIsOpen] = useState(false);

  const dropdownContainerStyle = {
    position: "relative",
    display: "inline-block",
  };

  const dropdownToggleStyle = {
    display: "flex",
    alignItems: "center",
    padding: "0.6rem 1.1rem",
    borderRadius: "0.5rem",
    textDecoration: "none",
    color: DefaultData.THEMECOLOR3,
    fontWeight: "500",
    cursor: "pointer",
  };

  const dropdownMenuStyle = {
    position: "absolute",
    top: "calc(100% + 5px)",
    left: 0,
    backgroundColor: "#FFFFFF",
    border: "1px solid #DEE2E6",
    borderRadius: "0.5rem",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    minWidth: "220px",
    padding: "0.5rem 0",
    zIndex: 1050,
    display: isOpen ? "block" : "none",
  };

  const dropdownItemStyle = {
    display: "flex",
    alignItems: "center",
    padding: "0.7rem 1.2rem",
    textDecoration: "none",
    color: "#333333",
    fontWeight: "500",
    cursor: "pointer",
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.bookings-dropdown')) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  return (
    <div className="bookings-dropdown" style={dropdownContainerStyle}>
      {/* Dropdown Toggle Button */}
      <div 
        style={dropdownToggleStyle} 
        onClick={toggleDropdown} 
      >
        <i className="ri-calendar-event-line me-2"></i>
        <span>Bookings</span>
        <i  
          className={`ri-arrow-down-s-line ms-1`} 
          style={{  
            transition: "transform 0.3s ease",  
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", 
            fontSize: "1.2rem" 
          }} 
        ></i>
      </div>

      {/* Dropdown Menu */}
      <div style={dropdownMenuStyle}>
        <Link  
          to="/flights"  
          style={dropdownItemStyle} 
          onClick={closeDropdown} 
        >
          <i className="ri-flight-takeoff-line me-2" style={{ fontSize: "1.1rem", color: "#555" }}></i>
          <span>Flights</span>
        </Link>

        <Link  
          to="/buses"  
          style={dropdownItemStyle} 
          onClick={closeDropdown} 
        >
          <i className="ri-bus-line me-2" style={{ fontSize: "1.1rem", color: "#555" }}></i>
          <span>Buses</span>
        </Link>

        <Link  
          to="/hotels"  
          style={dropdownItemStyle} 
          onClick={closeDropdown} 
        >
          <i className="ri-hotel-line me-2" style={{ fontSize: "1.1rem", color: "#555" }}></i>
          <span>Hotels</span>
        </Link>

        <Link  
          to="/sightseeing"  
          style={dropdownItemStyle} 
          onClick={closeDropdown} 
        >
          <i className="ri-map-pin-line me-2" style={{ fontSize: "1.1rem", color: "#555" }}></i>
          <span>Sightseeing</span>
        </Link>
      </div>
    </div>
  );
};

// New Dropdown component for Enquiries
const EnquiriesDropdown = ({ activeSection, getStyle }) => {
  const [isOpen, setIsOpen] = useState(false);

  const dropdownContainerStyle = {
    position: "relative",
    display: "inline-block",
  };

  const dropdownToggleStyle = {
    display: "flex",
    alignItems: "center",
    padding: "0.6rem 1.1rem",
    borderRadius: "0.5rem",
    textDecoration: "none",
    color: DefaultData.THEMECOLOR3,
    fontWeight: "500",
    cursor: "pointer",
  };

  const dropdownMenuStyle = {
    position: "absolute",
    top: "calc(100% + 5px)",
    left: 0,
    backgroundColor: "#FFFFFF",
    border: "1px solid #DEE2E6",
    borderRadius: "0.5rem",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    minWidth: "220px",
    padding: "0.5rem 0",
    zIndex: 1050,
    display: isOpen ? "block" : "none",
  };

  const dropdownItemStyle = {
    display: "flex",
    alignItems: "center",
    padding: "0.7rem 1.2rem",
    textDecoration: "none",
    color: "#333333",
    fontWeight: "500",
    cursor: "pointer",
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const closeDropdown = () => {
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.enquiries-dropdown')) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  return (
    <div className="enquiries-dropdown" style={dropdownContainerStyle}>
      {/* Dropdown Toggle Button */}
      <div 
        style={dropdownToggleStyle} 
        onClick={toggleDropdown} 
      >
        <i className="ri-question-answer-line me-2"></i>
        <span>Enquiries</span>
        <i  
          className={`ri-arrow-down-s-line ms-1`} 
          style={{  
            transition: "transform 0.3s ease",  
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", 
            fontSize: "1.2rem" 
          }} 
        ></i>
      </div>

      {/* Dropdown Menu */}
      <div style={dropdownMenuStyle}>
        <Link  
          to="/package/enquirylist"  
          style={dropdownItemStyle} 
          onClick={closeDropdown} 
        >
          <i className="ri-suitcase-line me-2" style={{ fontSize: "1.1rem", color: "#555" }}></i>
          <span>Packages</span>
        </Link>

        {/* <Link  
          to="/flights/enquirylist"  
          style={dropdownItemStyle} 
          onClick={closeDropdown} 
        >
          <i className="ri-flight-takeoff-line me-2" style={{ fontSize: "1.1rem", color: "#555" }}></i>
          <span>Flights</span>
        </Link>

        <Link  
          to="/buses/enquirylist"  
          style={dropdownItemStyle} 
          onClick={closeDropdown} 
        >
          <i className="ri-bus-line me-2" style={{ fontSize: "1.1rem", color: "#555" }}></i>
          <span>Buses</span>
        </Link>

        <Link  
          to="/hotels/enquirylist"  
          style={dropdownItemStyle} 
          onClick={closeDropdown} 
        >
          <i className="ri-hotel-line me-2" style={{ fontSize: "1.1rem", color: "#555" }}></i>
          <span>Hotels</span>
        </Link>

        <Link  
          to="/visa/enquirylist"  
          style={dropdownItemStyle} 
          onClick={closeDropdown} 
        >
          <i className="ri-passport-line me-2" style={{ fontSize: "1.1rem", color: "#555" }}></i>
          <span>Visas</span>
        </Link>

        <Link  
          to="/sightseeing/enquirylist"  
          style={dropdownItemStyle} 
          onClick={closeDropdown} 
        >
          <i className="ri-map-pin-line me-2" style={{ fontSize: "1.1rem", color: "#555" }}></i>
          <span>Sightseeing</span>
        </Link> */}
      </div>
    </div>
  );
};

export default function Header({ activeSection }) {
  const { user, loading } = useAuth();
  const planIsExpired = user ? isPlanExpired(user.endDate) : false;

  if (loading || !user) {
    return (
      <div 
        className="main-header" 
        style={{ 
          minHeight: "60px", 
          backgroundColor: "#FFFFFF", 
          borderBottom: "1px solid #DEE2E6", 
        }} 
      ></div>
    );
  }

  const navLinkStyle = {
    display: "flex",
    alignItems: "center",
    padding: "0.6rem 1.1rem",
    borderRadius: "0.5rem",
    textDecoration: "none",
    color: DefaultData.THEMECOLOR3,
    fontWeight: "500",
    transition: "background-color 0.2s ease, color 0.2s ease",
  };

  const activeNavLinkStyle = {
    ...navLinkStyle,
    backgroundColor: DefaultData.THEMECOLOR3,
    color: DefaultData.THEMECOLOR2,
  };

  const getStyle = (sectionName) => {
    return activeSection === sectionName ? activeNavLinkStyle : navLinkStyle;
  };

  return (
    <div 
      className="main-header" 
      style={{ 
        backgroundColor: DefaultData.THEMECOLOR1, 
        borderBottom: "1px solid #DEE2E6", 
        padding: "0.5rem 0.5rem", 
        position: "sticky", 
        top: "70px", 
        zIndex: 1020, 
        minHeight: "60px", 
        display: "flex", 
        alignItems: "center", 
      }} 
    >
      <div className="container-fluid">
        <nav className="d-flex align-items-center gap-1">
          <Link to={"/client/subscriptionlist"} style={getStyle("subscriptions")}>
            <i className="ri-repeat-line me-2"></i>
            <span>Subscriptions</span>
          </Link>
          
          <BookingsDropdown activeSection={activeSection} getStyle={getStyle} />
          
          <EnquiriesDropdown activeSection={activeSection} getStyle={getStyle} />

          <Link to={"/createpackage"} style={getStyle("createpackage")}>
            <i className="ri-suitcase-line me-2"></i>
            <span>Packages</span>
          </Link>
           
          <Link to={"/company/clients"} style={getStyle("clients")}>
            <i className="ri-group-line me-2"></i>
            <span>Clients</span>
          </Link>
          
          <Link to={"/company/suppliers"} style={getStyle("suppliers")}>
            <i className="ri-briefcase-line me-2"></i>
            <span>Suppliers</span>
          </Link>
          
          <Link to={"/company/dmcs"} style={getStyle("dmcs")}>
            <i className="ri-briefcase-line me-2"></i>
            <span>DMCS</span>
          </Link>
          
          <Link to={"/visamasterlist"} style={getStyle("visas")}>
            <i className="ri-passport-line me-2"></i>
            <span>Visas</span>
          </Link>
          
          <Link to={"/accounttypes"} style={getStyle("accounts")}>
            <i className="ri-money-dollar-circle-line me-2" />
            <span>Accounts</span>
          </Link>
          
          <Link to={"/create-template"} style={getStyle("templates")}>
            <i className="ri-layout-line me-2"></i>
            <span>Templates</span>
          </Link>
        </nav>
      </div>
    </div>
  );
}